// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q23LCQSqQ0__fTaU{padding-bottom:16px;border-style:solid;border-bottom-width:1px;border-color:var(--py-neutral-2)}.Q23LCQSqQ0__fTaU .ZCfej7yg0T0QSajD{display:inline}.Q23LCQSqQ0__fTaU .Hf8x98gRBTQtRCOv{display:inline}.Q23LCQSqQ0__fTaU .Hf8x98gRBTQtRCOv:hover{color:var(--py-primary-5) !important}.Q23LCQSqQ0__fTaU .Ck5YE7SrSwgsxS5b{display:inline}.HeWbPpsD9vEUNeLT{background-color:var(--py-neutral-0);border-radius:8px;padding:16px 16px 32px 16px}.xlQIeRfkO28HPIym{width:275px}.tJ85ZoAYijQPf8e2{height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customFieldRow": `Q23LCQSqQ0__fTaU`,
	"tooltip": `ZCfej7yg0T0QSajD`,
	"selectableFieldHistoryLabel": `Hf8x98gRBTQtRCOv`,
	"fieldHistoryLabel": `Ck5YE7SrSwgsxS5b`,
	"employeeCard": `HeWbPpsD9vEUNeLT`,
	"search": `xlQIeRfkO28HPIym`,
	"integrationImage": `tJ85ZoAYijQPf8e2`
};
export default ___CSS_LOADER_EXPORT___;
